module.exports = __webpack_public_path__ + "img/IMG_1955.151d38c0.jpg";